import React from 'react';

function Queries() {

   return (

      <section id="cta" className="cta">
        <div className="container">
          <div className="row">
            <div className="col-lg-9 text-center text-lg-start">
              <h3>Get In Touch</h3>
              <p> If you need any assistance or have questions or comments, you can reach out to our dedicated support team at Telsim NBN<sup>&reg;</sup> Broadband either by phone or email. We're here to listen to your concerns and provide personalized assistance. Don't hesitate to contact us now for seamless Telsim connectivity.</p>
            </div>
            <div className="col-lg-3 cta-btn-container text-center">
              <a className="cta-btn align-middle"  href="https://www.telsim.com.au/contact-us/">CONTACT US</a>
            </div>
          </div>
        </div>
      </section>

   );
}

export default Queries;
